/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'bootstrap/dist/js/bootstrap'
import $ from 'jquery';
import select2 from 'select2';
import 'select2/dist/css/select2.css';
import 'semantic-ui-css/semantic.min.css'
import 'webpack-jquery-ui'
import 'webpack-jquery-ui/css'
import { createConsumer } from '@rails/actioncable'
console.log('jquery', $);
const componentRequireContext = require.context('components', true)
const ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
window.ActionCableConsumer = createConsumer('/cable')

$(document).ready(function() {
  $('select').select2();
});
